import {WIDTH, HEIGHT, PADDING} from 'components/effects/plane/constants.js';
import {reader} from "messaging/reader.js";
import {crossedHorizontal, crossedVertical} from './boundary.js';
import {density} from './operations.js';
import {publishPlanarBounce} from 'messaging/messages.js';
import {doc} from './documentation.js';
import {centroid, diameter} from './geometry.js';
import {getSlicedParameters, sliceParams} from './params.js';
import {lazy} from './lazy.js';
import {toRadians} from './utils.js';
const {keys, values} = Object;

doc(
"bounce",
{
    "degrees": "The direction that the bounce goes by"
},
"Moves the parameters by direction of the degrees, and bounces off any walls");
export const bounce = (degrees) => {
let slicer = sliceParams();
let xFactor = 1;
let yFactor = 1;
const _reader = reader("planarReset");
return (parameters, speed=1, ... args) => {
    let effect = args[4];

    if (_reader().some(x => x === effect.id)) {
        // then we reset
        xFactor = 1;
        yFactor = 1;
    }

    let _degrees = -1*(lazy(degrees, speed, ... args) - 90);
    let radians = toRadians(360 - _degrees);
    let slope = Math.tan(radians);
    let y = -1*yFactor;
    let x = xFactor*slope * y;
    if (_degrees === 90) {
        x = xFactor;
        y = 0;
    } else if (_degrees === -90) {
        x = -1 * xFactor;
        y = 0;
    } else if (_degrees == 0) {
        y = -1*yFactor;
        x = 0;
    }

    let getDensity = density([speed, ...args]);
    // when we reach the horizontal sides, we switch x to -x
    // when we reach the vertical top/bottom, we switch y to -y
    let crossedX = false;
    let crossedY = false;
    if (crossedHorizontal(values(parameters), x, speed, getDensity)) {
        xFactor *= -1;
        x *= -1;
        crossedX = true;
    }
    if (crossedVertical(values(parameters), y, speed, getDensity)) {
        yFactor *= -1;
        y *= -1;
        if (!crossedX) {
            xFactor *= -1;
        }
        crossedY = true;
    }

    if (!crossedX && !crossedY) {
        let _parameters = getSlicedParameters(slicer, parameters, [speed, ... args]);
        parameters = _parameters;
    } else {
        publishPlanarBounce(crossedX);
    }

    let p = keys(parameters).map(
        id => {
            let coord = parameters[id];
            let _density = getDensity(coord.x, coord.y, coord);
            let x1 = coord.x + x * speed * 10 / _density;
                let y1 = coord.y + y * speed * 10 / _density;
                let ret ={};
                ret[id] = {x: x1, y: y1, density: _density};
                return ret;
            })
            .reduce((a,b) => ({... a, ... b}), {});
        return p;
    };
};
